
























import Vue from 'vue';
import { RouterOptions } from 'vue-router';

export default Vue.extend({
    name: 'Navigation',
    props: ['value'],
    data() {
        const $router: any = this.$router;
        const options = $router.options as RouterOptions;

        return {
            show: this.value,
            routes: options.routes
                ?.filter((route) => route.meta?.inNavigation)
                .sort((a, b) => a.meta.position - b.meta.position),
        };
    },
    methods: {
        logout() {
            this.$store.dispatch('logout');
            this.$router.replace('/login')
        },
    },
    watch: {
        show(value) {
            this.$emit('input', value);
        },
        value(value) {
            this.show = value;
        },
    },
});
